import React from 'react';
import PropTypes from 'prop-types';
import ReactFitText from 'react-fittext';
import SectionTitle from '../home-section-title';
import Reveal from '../../reveal';
import RevealSlideDown from '../../animations/reveal-slide-down';
import GradientBGTransition from '../../gradient-bg-transition';
import styles from './home-approach.module.css';
import B2ME from '../../../assets/global-logos/b2me.svg';
import B2B from '../../../assets/global-logos/b2b.svg';
import B2C from '../../../assets/global-logos/b2c.svg';
import B2E from '../../../assets/global-logos/b2e.svg';
import { Spring } from 'react-spring';
import * as easings from 'd3-ease';

const Description = props => {
  const { animation } = props;
  return (
    <ReactFitText compressor={1.35} minFontSize={16} maxFontSize={26}>
      <p className={styles.description} style={animation}>
        Whether it’s B2B, B2C, or B2E, we can help you make the connections that
        matter-to the people who matter to your business.
      </p>
    </ReactFitText>
  );
};

const Title = props => {
  const { isInView } = props;
  const b2meTitles = [
    { component: <B2ME />, multiplier: 500 },
    { component: <B2B />, multiplier: 750 },
    { component: <B2C />, multiplier: 1000 },
    { component: <B2E />, multiplier: 1250 },
  ];
  return b2meTitles.map((logo, index) => {
    const animationConfig = {
      duration: 1000,
      easing: easings.easeCubicOut,
    };
    return (
      <Spring
        key={index}
        from={{ opacity: '0' }}
        to={{
          opacity: isInView ? '1' : '0',
        }}
        delay={b2meTitles[index].multiplier}
      >
        {animation => {
          return (
            <div style={{ opacity: animation.opacity }}>{logo.component}</div>
          );
        }}
      </Spring>
    );
  });
};

const HomeApproachContent = props => {
  const { isInView } = props;
  const settings = {
    sectionTitle: 'Our Approach',
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.message}>
          <Title isInView={isInView} />
        </div>
        <div className={styles.content}>
          <RevealSlideDown isInView={isInView} delay={400}>
            <SectionTitle
              sectionName={settings.sectionTitle}
              isInView={isInView}
              white={true}
            />
            <Description />
          </RevealSlideDown>
        </div>
      </div>
      <GradientBGTransition />
    </div>
  );
};

const HomeApproach = props => {
  return (
    <React.Fragment>
      <Reveal>
        <HomeApproachContent {...props} />
      </Reveal>
    </React.Fragment>
  );
};

export default HomeApproach;



// WEBPACK FOOTER //
// ./src/components/home/home-approach/index.js